var _ChevronDown;
import * as React from 'react';
import { ChevronDown } from '@ovpn-ui/icons';
import { Tooltip } from '@ovpn-ui/core';
import { lockScroll, unlockScroll } from '@ovpn-ui/utils';
import { SidebarPanel as SidebarPanelWrapper, SidebarToggle } from './SidebarPanel.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const defaultElement = 'div';
function SidebarPanel(props) {
  const {
    children,
    open,
    onToggle,
    mobile
  } = props;
  const [isFocusInside, setIsFocusInside] = React.useState(false);
  React.useEffect(() => {
    if (isFocusInside && open) {
      lockScroll();
    } else {
      unlockScroll();
    }
    return () => {
      unlockScroll();
    };
  }, [isFocusInside, open]);
  return /*#__PURE__*/_jsxs(SidebarPanelWrapper, {
    $open: open,
    $mobile: mobile,
    className: "ovpn-sidebar",
    role: "navigation",
    "aria-label": "Sidebar",
    "data-testid": "data-testid",
    onMouseEnter: () => {
      setIsFocusInside(true);
    },
    onMouseLeave: () => {
      setIsFocusInside(false);
    },
    onTouchStart: () => {
      setIsFocusInside(true);
    },
    onTouchEnd: () => {
      setIsFocusInside(false);
    },
    children: [!mobile && onToggle && /*#__PURE__*/_jsx(Tooltip, {
      trigger: /*#__PURE__*/_jsx(SidebarToggle, {
        "aria-label": open ? 'collapse sidebar' : 'expand sidebar',
        $on: open,
        onClick: onToggle,
        children: _ChevronDown || (_ChevronDown = /*#__PURE__*/_jsx(ChevronDown, {}))
      }),
      placement: "right",
      children: open ? 'Collapse' : 'Expand'
    }), children]
  });
}
export default SidebarPanel;